import React from "react";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { Formik, ErrorMessage, Field } from "formik";

import * as Yup from "yup";

import styled from "tachyons-components";

import styles from "./styles.module.scss";

import { setCityObject } from "../../../store/actions/city";

import { getModalSplitByType } from '../../../store/selectors';

const splitNumber = Yup.number().min(0).max(100);
const ModalSplitSchema = Yup.object().shape({
  car: splitNumber,
  twoWheel: splitNumber,
  threeWheel: splitNumber,
  publicTransit: splitNumber,
});

// TBD how to run this after everything fires
const areValuesValid = (values) => {
  // All values are numbers
  const valuesSumToHundred = values.reduce((a,b) => +a + +b, 0) === 100;
  return valuesSumToHundred;
}

const Entry = styled('div')`
  pa1 black-80
`
const Label = styled("label")`
  f6 ib mb2
`;

const Input = styled("input")`
  input-reset ba b--black-20 pa2 mb1 ib measure
`;


const displayNameMap = {
  car: '4-wheel (e.g., passenger car)',
  publicTransit: 'Public Transit (e.g., bus, metro)',
  twoWheel: '2-wheel (e.g., motorcycle)',
  threeWheel: '3-wheel (e.g., rickshaw)',
}

const CustomInputComponent = ({
  field,
  form: { touched, errors },
  ...props
}) => (
    <Entry className={styles.modalSplitRow}>
      <Label className={styles.splitLabel}>{displayNameMap[field.name]}</Label>
      <Input className={styles.splitTextbox} type="text" {...field} {...props} />
      {touched[field.name] &&
        errors[field.name] && <div className={styles.error}>{errors[field.name]}</div>}
    </Entry>
  );



const BaseModalSplitForm = props => {
  return (
  <Formik
    initialValues={{
      car: props.car * 100,
      publicTransit: props.publicTransit * 100,
      twoWheel: props.twoWheel * 100,
      threeWheel: props.threeWheel * 100
    }}
    validationSchema={ModalSplitSchema}
    onSubmit={(values, actions) => {
      const valuesAreValid = areValuesValid(Object.values(values));
      if (valuesAreValid) {
        props.setCityObject('vehicleModalSplit', { // coerce back down to percentages
          car: +values.car / 100,
          publicTransit: +values.publicTransit / 100,
          twoWheel: +values.twoWheel / 100,
          threeWheel: +values.threeWheel / 100,
        });

      } else {
        actions.setStatus({
          submission: `Modal splits must sum to 100, presently they sum to ${Object.values(values).reduce((a, b) => +a + +b)}`,
        })
      }
      actions.setSubmitting(false);
    }}
    enableReinitialize={true}
  >
    {({
      handleSubmit,
      isSubmitting,
      errors,
      status
    }) => {
      return (
      <form onSubmit={handleSubmit}>
        <div className={styles.tableHead}>
          <div className={styles.questionLabel}>Motorized Transport Modal Split (percent in current year)</div>
        </div>
        <Field name="twoWheel" type='text' component={CustomInputComponent}/>
        <Field name="threeWheel" type='text' component={CustomInputComponent}/>
        <Field name="car" type='text' component={CustomInputComponent}/>
        <Field name="publicTransit" type='text' component={CustomInputComponent}/>
        {status && status.submission && <div className={styles.error}>{status.submission}</div>}
        <div className={styles.submitRow}>
          <button type="submit" disabled={isSubmitting} className={styles.submitButton}>
            Save Splits
          </button>
        </div>
      </form>
    )}
    }
  </Formik>
)};

const mapStateToProps = (state, props) => {
  const modalSplit = getModalSplitByType(state);
  return {
    car: modalSplit.car,
    twoWheel: modalSplit.twoWheel,
    threeWheel: modalSplit.threeWheel,
    publicTransit: modalSplit.publicTransit,
  }
}

const mapDispatchToProps = {
  setCityObject
}

const ModalSplitForm = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(BaseModalSplitForm);

export { ModalSplitForm};



// WEBPACK FOOTER //
// ./src/pages/modelCity/panes/modalSplitForm.js